import Header, { HeaderProps } from '@/components/atoms/Header';
import { theme } from '@/styles/theme';
import Image from 'next/image';
import logo_chippu_place from '@/assets/logo_chippu_place.svg';

export default function CabecalhoLogarFallback(props: HeaderProps) {
  return (
    <Header {...props}>
      <div
        style={{
          display: 'flex',
          flex: 1,
          justifyContent: 'center',
        }}
      >
        <div
          style={{
            display: 'flex',
            flexDirection: 'row',
            flex: 1,
            padding: `0 ${theme.spacing[4]}px`,
            maxWidth: 700,
          }}
        >
          <Image
            src={logo_chippu_place}
            alt="Chippu Place logo"
            height={27}
            width={82}
            priority
            style={{
              marginRight: theme.spacing[4],
            }}
          />
        </div>
      </div>
    </Header>
  );
}
